import ReactDOM from 'react-dom'

import { parseJSONFromScript } from '../shared/parseJSONFromScript'
import Canvas from './components/Canvas'
import { SettingsSmall, SettingsSmallGeo } from './constants/settings'
import Treemap from './treemap'
import { MapSubtypeId, MapTypeId, PerfData, ScaleId } from './types'
import * as mapUtils from './utils'

const CANVAS_WIDTH = 400
const CANVAS_HEIGHT_GEO = 235
const CANVAS_HEIGHT = 300

async function renderTreemaps(props: { perfDataSec: PerfData; perfDataGeo: PerfData; cacheBuster: number }) {
  let precomputedData
  try {
    precomputedData = await mapUtils.fetchBaseData('hp.json', props.cacheBuster)
  } catch {
    return
  }

  if (props.perfDataSec) {
    const initData = mapUtils.getMapData(precomputedData.sec, props.perfDataSec)
    const treemap = new Treemap({
      data: initData,
      width: CANVAS_WIDTH,
      height: CANVAS_HEIGHT,
      scaleId: ScaleId.DayPerf,
      countIndustryPerf: false,
      countSectorPerf: true,
      settings: SettingsSmall,
      type: MapTypeId.Sector,
      subtype: MapSubtypeId.DayPerf,
      isSmall: true,
      zoomLevels: [1],
    })

    window.FinvizIndexSecMap = treemap

    ReactDOM.render(
      <Canvas
        treemap={treemap}
        scale={{ id: ScaleId.DayPerf, name: '', tooltip: null }}
        hover={false}
        legend={false}
        zoom={false}
        alt="S&P 500 Map"
      />,
      document.getElementById('treemap-small')
    )
  }

  if (props.perfDataGeo) {
    const initData = mapUtils.getMapData(precomputedData.geo, props.perfDataGeo)
    const treemap = new Treemap({
      data: initData,
      width: CANVAS_WIDTH,
      height: CANVAS_HEIGHT_GEO,
      scaleId: ScaleId.DayPerf,
      countIndustryPerf: true,
      countSectorPerf: false,
      settings: SettingsSmallGeo,
      type: MapTypeId.World,
      subtype: MapSubtypeId.DayPerf,
      isSmall: true,
      zoomLevels: [1],
    })

    window.FinvizIndexGeoMap = treemap

    ReactDOM.render(
      <Canvas
        treemap={treemap}
        scale={{ id: ScaleId.DayPerf, name: '', tooltip: null }}
        hover={false}
        legend={false}
        zoom={false}
        alt="World Map"
      />,
      document.getElementById('treemap-small-geo')
    )
  }
}

const mapProps = parseJSONFromScript<{ perfDataSec: PerfData; perfDataGeo: PerfData; cacheBuster: number }>('map-data')
if (mapProps) renderTreemaps(mapProps)
